"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.StyledContainer = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const container_1 = __importDefault(require("../container"));
const PREFIX = "Hero";
exports.classes = {
    slim: `${PREFIX}-slim`,
    keyline: `${PREFIX}-keyline`,
    wrapper: `${PREFIX}-wrapper`,
    content: `${PREFIX}-content`,
    title: `${PREFIX}-title`,
    cta: `${PREFIX}-cta`,
    image: `${PREFIX}-image`,
    light: `${PREFIX}-light`,
    breadcrumbs: `${PREFIX}-breadcrumbs`,
    lvl1: `${PREFIX}-lvl1`,
    lvl2: `${PREFIX}-lvl2`,
    lvl3: `${PREFIX}-lvl3`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    minHeight: "auto",
    flexDirection: "column",
    backgroundColor: theme.colours.blue800,
    color: theme.colours.white,
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.up(769)]: {
        flexDirection: "row",
        height: "auto"
    },
    [`&.${exports.classes.slim}`]: {
        [theme.breakpoints.up(769)]: {
            height: "auto"
        },
        [`.${exports.classes.wrapper}`]: {
            paddingBottom: "8px"
        }
    },
    [`&.${exports.classes.keyline}`]: {
        borderBottom: `12px solid ${theme.colours.accent}`,
        [`&.${exports.classes.lvl1}`]: {
            borderBottom: `8px solid ${theme.colours.accent}`
        },
        [`&.${exports.classes.lvl2}, &.${exports.classes.lvl3}`]: {
            borderBottom: `4px solid ${theme.colours.accent}`
        }
    },
    [`.${exports.classes.wrapper}`]: {
        display: "flex",
        width: "100%",
        minHeight: "auto",
        padding: "24px 0 40px 0",
        flexDirection: "column",
        [theme.breakpoints.up(769)]: {
            width: "calc(50% + 12px)",
            height: "100%",
            paddingRight: "24px"
        }
    },
    [`.${exports.classes.content}`]: {
        height: "100%",
        marginTop: "auto",
        marginBottom: "auto",
        [theme.breakpoints.up(769)]: {
            marginTop: "auto",
            marginBottom: "auto"
        },
        [theme.breakpoints.up("xl")]: {
            paddingBottom: 0
        }
    },
    [`.${exports.classes.title}`]: {
        // NOTE: This gets rid of the next line high characters
        lineHeight: 1.2,
        "&::after": {
            // NOTE: Fix the next slide being visible
            marginLeft: "1px"
        },
        // NOTE: none of the headers are truncated on mobile
        [theme.breakpoints.up(769)]: {
            WebkitLineClamp: 2
        }
    },
    [`.${exports.classes.breadcrumbs}`]: {
        marginBottom: "24px"
    },
    [`.${exports.classes.cta}`]: {
        marginTop: "24px",
        display: "block",
        width: "fit-content",
        // NOTE: Fix the next slide being visible
        marginLeft: "1px",
        [theme.breakpoints.up(769)]: {
            marginTop: "32px"
        }
    },
    [`.${exports.classes.image}`]: {
        width: "100%",
        height: "500px",
        overflow: "hidden",
        "&::after": {
            content: '""',
            display: "block",
            paddingTop: "100%"
        },
        [theme.breakpoints.up(769)]: {
            position: "absolute !important",
            top: 0,
            left: "calc(50% + 12px)",
            width: "calc(50vw - 12px)",
            height: "100%",
            maxHeight: "none",
            "&::after": {
                content: "''"
            }
        }
    },
    [`&.${exports.classes.light}`]: {
        backgroundColor: theme.colours.pearl,
        color: theme.colours.charcoal,
        [`.${exports.classes.title}`]: {
            WebkitLineClamp: "inherit"
        }
    },
    [`&.${exports.classes.lvl1}`]: {
        [theme.breakpoints.up(769)]: {
            minHeight: "450px"
        }
    }
}));
exports.StyledContainer = (0, styles_1.styled)(container_1.default)(({ theme }) => ({
    height: "100%",
    padding: "0 16px",
    [theme.breakpoints.up(769)]: {
        padding: "0 24px"
    }
}));
exports.Text = (0, styles_1.styled)("div")(({ theme }) => ({
    minHeight: "auto",
    fontSize: "18px",
    lineHeight: 1.4,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.up(769)]: {
        fontSize: "20.25px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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